/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

/** Frequently used emojis for quick insertion (no external data dependency). */
export const DEFAULT_COMMON_EMOJIS = [
  '😄',
  '😁',
  '🤣',
  '😂',
  '🙂',
  '😉',
  '😊',
  '🥰',
  '😍',
  '😘',
  '😋',
  '😜',
  '🤪',
  '😏',
  '🥵',
  '🤤',
  '🫦',
  '😈',
  '😇',
  '🥲',
  '😢',
  '😭',
  '😤',
  '😡',
  '🤬',
  '🥳',
  '😎',
  '🤔',
  '🤫',
  // '🤐',
  '😴',
  '🤯',
  '🥺',
  '🙄',
  '🤷',
  '👍',
  '👎',
  '👏',
  '🙏',
  '👌',
  '✌️',
  '🤞',
  '💪',
  '🔥',
  '💯',
  '❤️',
  '🧡',
  '💛',
  '💚',
  '💙',
  '💜',
  '🤎',
  '🖤',
  '🤍',
  '💔',
  '💋',
  '👄',
  '👅',
  '🍑',
  '🍆',
  '🍒',
  '🍌',
  '💦',
  '🎉',
  '👀',
] as const
